import { ACTIONS } from "../../common/constants";

const initialState = { existingCartItemCount: 0, cartItemCount: 0 };

const cartItemCountDataReducer = function (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_CART_ITEM_COUNT:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default cartItemCountDataReducer;
